import { useEffect, useState } from "react";
import { navItems, tickerItems } from "@/mocks/home";

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed inset-x-0 top-0 z-50">
      <div className="bg-primary-700 text-background-50">
        <div className="flex items-center gap-3 px-4 md:px-6 h-9 overflow-hidden">
          <span className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium text-accent-200">
            <i className="ri-notification-3-line"></i>
            本站提示
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee gap-12">
              {[...tickerItems, ...tickerItems].map((item, index) => (
                <span key={index} className="whitespace-nowrap text-xs text-background-50/90">
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <header
        className={`transition-colors duration-300 ${
          scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
        }`}
      >
        <div className="flex items-center justify-between px-4 md:px-6 h-16 md:h-[72px]">
          <a href="#top" className="flex items-center gap-2.5 group">
            <span
              className={`w-9 h-9 rounded-lg flex items-center justify-center ${
                scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
              }`}
            >
              <i className="ri-book-marked-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-tight">
              <strong
                className={`font-heading text-base md:text-lg font-bold ${
                  scrolled ? "text-foreground-950" : "text-background-50"
                }`}
              >
                善良的女秘书
              </strong>
              <span
                className={`text-[11px] tracking-wide ${
                  scrolled ? "text-foreground-500" : "text-background-50/80"
                }`}
              >
                资源渠道查询导航
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                    : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#channels"
              className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-compass-3-line"></i>
              查看渠道
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
            aria-expanded={mobileOpen}
              onClick={() => setMobileOpen((v) => !v)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md ${
                scrolled ? "text-foreground-900 bg-background-100" : "text-background-50 bg-background-50/15"
              }`}
            >
              <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 pb-4">
            <div className="grid grid-cols-2 gap-2 pt-2">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={() => setMobileOpen(false)}
                  className="px-3 py-2.5 text-sm text-foreground-700 bg-background-100 rounded-md hover:text-primary-600"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </header>
    </div>
  );
}